import { useMediaQuery } from "react-responsive";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import About from "./components/AboutusPage/about";
import SignIn from "./components/Account/SignIn";
import SignUp from "./components/Account/SignUp";
import CartPage from "./components/AddtoCart/addtocart";
import Checkout from "./components/checkoutPage/checkout";
import Contact from "./components/ContactPage/contact";
import FAQ from "./components/FAQ/faq";
import Header from "./components/HomePage/header";
import Home from "./components/HomePage/homepage";
import NotificationProvider from "./components/Notification/notification";
import PrivacyPolicy from "./components/privacyPolicy/privacy";
import ProductDetails from "./components/productDetails/productDetails";
import ProductPage from "./components/ProductPage/product";
import ServicePage from "./components/Services/servicePage";
import SmoothScroll from "./components/SmoothScroll/smoothScroll";

import TermsAndConditions from "./components/Terms-conditions/terms-conditions";
import Wishlist from "./components/WishlistPage/wishlist";

function App() {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1024 });
  const isSmallLaptop = useMediaQuery({ minWidth: 1025, maxWidth: 1440 });

  return (
    <NotificationProvider>
      <Router>
        <SmoothScroll>
          <div>
            {isMobile && <div></div>}
            {isTablet && <div></div>}
            {isSmallLaptop && <div></div>}
            {!isMobile && !isTablet && !isSmallLaptop && <div></div>}
          </div>

          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Header />
                  <Home />
                </>
              }
            />

            <Route path="/product/:slug/:id" element={<ProductDetails />} />
            <Route
              path="/product"
              element={
                <>
                  <Header />
                  <ProductPage />
                </>
              }
            />

            <Route
              path="/service"
              element={
                <>
                  <Header />
                  <ServicePage />
                </>
              }
            />
            <Route
              path="/privacy"
              element={
                <>
                  <Header />
                  <PrivacyPolicy />
                </>
              }
            />
            <Route
              path="/faq"
              element={
                <>
                  <Header />
                  <FAQ />
                </>
              }
            />
            <Route
              path="/about"
              element={
                <>
                  <Header />
                  <About />
                </>
              }
            />
            <Route
              path="/contact"
              element={
                <>
                  <Header />
                  <Contact />
                </>
              }
            />

            <Route
              path="/cart"
              element={
                <>
                  <Header />
                  <CartPage />
                </>
              }
            />
            <Route
              path="/checkout"
              element={
                <>
                  <Header />
                  <Checkout />
                </>
              }
            />
            <Route
              path="/wishlist"
              element={
                <>
                  <Header />
                  <Wishlist />
                </>
              }
            />

            <Route
              path="/terms-conditions"
              element={
                <>
                  <Header />
                  <TermsAndConditions />
                </>
              }
            />

            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
          </Routes>
        </SmoothScroll>
      </Router>
    </NotificationProvider>
  );
}

export default App;
